'use strict';

class Auth {

    showAuthTypeForm() {

        fetch('/auth/get-auth-type-form', {method: 'GET'})
            .then(resp => resp.json())
            .then(resp => {

                popup.insertData(resp.content);
                popup.open();

            });

    }

    processSMS() {

        smsAuth.showForm();

    }

    processESIA() {

        fetch('/auth/esia/api/v1/get-auth-url')
            .then(resp => resp.json())
            .then(resp => {

                window.location.href = resp.url;

            })

    }

}

const auth = new Auth;
